import React, { type ForwardedRef, type PropsWithChildren } from "react";

import { type Table } from "@devexpress/dx-react-grid-bootstrap4";

interface Props extends PropsWithChildren<Table.DataCellProps> {
  forwardedRef?: ForwardedRef<HTMLTableCellElement>;
}

export const TableCell = ({
  column,
  value,
  children,
  tableRow,
  tableColumn,
  row,
  forwardedRef,
  ...restProps
}: Props) => {
  let cellValue = children || value;
  if (
    cellValue === undefined ||
    cellValue === null ||
    Number.isNaN(cellValue)
  ) {
    cellValue = "";
  }

  return (
    <td ref={forwardedRef} {...restProps}>
      {cellValue}
    </td>
  );
};
